import React from "react";

function DVLACheck() {
  return (
    <>
      {/* CSS for print functionality to hide everything but the form */}
      <style>
        {`
          @media print {
            body * {
              visibility: hidden; /* Hide all elements on the page */
            }
            #DVLACheckForm, #DVLACheckForm * {
              visibility: visible; /* Make only the form and its children visible */
            }
            #DVLACheckForm {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              margin: 0;
              padding: 0;
              box-shadow: none;
              border: none;
            }
            /* Set up page margins for printing */
            @page {
              size: A4;
              margin: 20mm; /* Add a reasonable margin to prevent content from being cut off */
            }
            /* Hide print button during printing */
            .print-button {
              display: none;
            }
          }
        `}
      </style>
      <div id="DVLACheckForm" className="p-4 border rounded-lg bg-white shadow-md font-sans">
        <h3 className="text-2xl font-semibold mb-4 text-gray-800">Driver License, CPC & Tachograph Check</h3>

        <form>
          {/* Driver Name */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="driverName">
              Driver Name:
            </label>
            <input
              type="text"
              id="driverName"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter driver name"
            />
          </div>

          {/* Driver Licence No. */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="driverLicenceNo">
              Driver Licence No.:
            </label>
            <input
              type="text"
              id="driverLicenceNo"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter driver licence number"
            />
          </div>

          {/* Licence Expiry Date */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="licenceExpiryDate">
              Licence Expiry Date:
            </label>
            <input
              type="date"
              id="licenceExpiryDate"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          
          {/* Offences Section */}
          <div className="mb-6">
            <h4 className="text-xl font-semibold mb-4 text-gray-800">Offences (up to 4)</h4>
            
            {/* Offence 1 */}
            <div className="mb-4 p-4 border rounded-lg bg-gray-50">
              <h5 className="text-lg font-medium mb-2 text-gray-700">Offence 1</h5>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700" htmlFor="offenceCode1">Offence Code:</label>
                  <input type="text" id="offenceCode1" className="p-2 border border-gray-300 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="e.g. SP30"/>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700" htmlFor="offenceDate1">Offence Date:</label>
                  <input type="date" id="offenceDate1" className="p-2 border border-gray-300 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-500"/>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700" htmlFor="fineAmount1">Fine Amount:</label>
                  <input type="text" id="fineAmount1" className="p-2 border border-gray-300 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="e.g. £100"/>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700" htmlFor="pointsReceived1">Points Received:</label>
                  <input type="text" id="pointsReceived1" className="p-2 border border-gray-300 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="e.g. 3"/>
                </div>
              </div>
            </div>

            {/* Offence 2 */}
            <div className="mb-4 p-4 border rounded-lg bg-gray-50">
              <h5 className="text-lg font-medium mb-2 text-gray-700">Offence 2</h5>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700" htmlFor="offenceCode2">Offence Code:</label>
                  <input type="text" id="offenceCode2" className="p-2 border border-gray-300 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="e.g. SP30"/>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700" htmlFor="offenceDate2">Offence Date:</label>
                  <input type="date" id="offenceDate2" className="p-2 border border-gray-300 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-500"/>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700" htmlFor="fineAmount2">Fine Amount:</label>
                  <input type="text" id="fineAmount2" className="p-2 border border-gray-300 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="e.g. £100"/>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700" htmlFor="pointsReceived2">Points Received:</label>
                  <input type="text" id="pointsReceived2" className="p-2 border border-gray-300 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="e.g. 3"/>
                </div>
              </div>
            </div>

            {/* Offence 3 */}
            <div className="mb-4 p-4 border rounded-lg bg-gray-50">
              <h5 className="text-lg font-medium mb-2 text-gray-700">Offence 3</h5>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700" htmlFor="offenceCode3">Offence Code:</label>
                  <input type="text" id="offenceCode3" className="p-2 border border-gray-300 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="e.g. SP30"/>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700" htmlFor="offenceDate3">Offence Date:</label>
                  <input type="date" id="offenceDate3" className="p-2 border border-gray-300 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-500"/>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700" htmlFor="fineAmount3">Fine Amount:</label>
                  <input type="text" id="fineAmount3" className="p-2 border border-gray-300 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="e.g. £100"/>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700" htmlFor="pointsReceived3">Points Received:</label>
                  <input type="text" id="pointsReceived3" className="p-2 border border-gray-300 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="e.g. 3"/>
                </div>
              </div>
            </div>

            {/* Offence 4 */}
            <div className="mb-4 p-4 border rounded-lg bg-gray-50">
              <h5 className="text-lg font-medium mb-2 text-gray-700">Offence 4</h5>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700" htmlFor="offenceCode4">Offence Code:</label>
                  <input type="text" id="offenceCode4" className="p-2 border border-gray-300 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="e.g. SP30"/>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700" htmlFor="offenceDate4">Offence Date:</label>
                  <input type="date" id="offenceDate4" className="p-2 border border-gray-300 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-500"/>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700" htmlFor="fineAmount4">Fine Amount:</label>
                  <input type="text" id="fineAmount4" className="p-2 border border-gray-300 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="e.g. £100"/>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700" htmlFor="pointsReceived4">Points Received:</label>
                  <input type="text" id="pointsReceived4" className="p-2 border border-gray-300 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="e.g. 3"/>
                </div>
              </div>
            </div>
          </div>

          {/* CPC Card No. */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="CPCCardNo">
              CPC Card No.:
            </label>
            <input
              type="text"
              id="CPCCardNo"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter CPC card number"
            />
          </div>

          {/* CPC Expiry Date */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="cpcExpiryDate">
              CPC Expiry Date:
            </label>
            <input
              type="date"
              id="cpcExpiryDate"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Tachograph Card No. */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="tachographCardNo">
              Tachograph Card No.:
            </label>
            <input
              type="text"
              id="tachographCardNo"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter tachograph card number"
            />
          </div>

          {/* Tachograph Card Expiry Date */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="tachographCardExpiryDate">
              Tachograph Card Expiry Date:
            </label>
            <input
              type="date"
              id="tachographCardExpiryDate"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Legal to Drive */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700">
              Legal to Drive:
            </label>
            <div className="flex flex-wrap items-center space-x-4">
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Yes</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">No</span>
              </label>
            </div>
          </div>

          {/* Checked By */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="checkedBy">
              Checked By (Name):
            </label>
            <input
              type="text"
              id="checkedBy"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter name of person checking"
            />
          </div>

          {/* Week Commencing */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="weekCommencing">
              Week Commencing:
            </label>
            <input
              type="date"
              id="weekCommencing"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Driver Signature */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="driverSignature">
              Signature of Driver:
            </label>
            <input
              type="text"
              id="driverSignature"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Driver's signature"
            />
          </div>

          {/* Manager Signature */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="managerSignature">
              Signature of Manager:
            </label>
            <input
              type="text"
              id="managerSignature"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Manager's signature"
            />
          </div>

          {/* Legal Disclaimer */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700">
              Legal Disclaimer:
            </label>
            <div className="flex items-center space-x-4">
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">I confirm that the above information is accurate and up to date.</span>
              </label>
            </div>
          </div>

          {/* Notes Section */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="notes">
              Notes:
            </label>
            <textarea
              id="notes"
              className="p-3 border border-gray-300 rounded-lg w-full h-24 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Record any issues or actions required, such as licence renewals or CPC training"
            />
          </div>

          {/* Print Button */}
          <div className="mb-4 text-right">
            <button
              type="button"
              onClick={() => window.print()}
              className="w-full md:w-64 bg-blue-500 text-white p-4 rounded-lg hover:bg-blue-600 transition-colors shadow-lg print-button"
            >
              Print Form
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default DVLACheck;
